export default __webpack_public_path__ + "static/media/plus-gray.69c56f06.svg";